// removed by extract-text-webpack-plugin
module.exports = {"container":"container___3QrFn","hot-sale-product":"hot-sale-product___1ygsc"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Shop/Home/ShopHome/components/Tabs/Components/PageList/index.modules.less
// module id = 727
// module chunks = 431